
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { component as Viewer } from 'v-viewer';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import { IImage } from '@/common/interface';

interface IAllShopImages {
  elements?: any[];
}
@Component({
  components: {
    Viewer,
  },
})
export default class ShopImagesAlbumField extends Vue {
  val: IImage[] = [];

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  AuditForm!: any;

  @Prop()
  value!: IImage[];

  @lazyInject(ShopService)
  shopService!: ShopService;

  albumBool = false;

  albumData: any = {};

  dictionaryObject: any = {
    env: '环境',
    product_service: '产品服务',
    other: '其他',
    inner_env: '店内环境',
    video: '视频',
    header: '头图',
    shops: '适用门店',
    template_name: '模版名称',
    cover: '封面图',
    new: '新模版名称',
    old: '原模版名称',
    add: '本次新增',
    delete: '本次删除',
  };

  @Watch('value')
  watchValue() {
    console.log(this.value);
    if (this.value && this.value.length) {
      this.val = [...this.value];
    } else {
      this.val = [];
    }
  }

  @Watch('AuditForm')
  async watchAuditForm() {
    // this.watchValue();
    console.log(this.AuditForm, 'AuditForm');
    const is_album = this.AuditForm.is_album ? +this.AuditForm.is_album : 0;
    if (is_album) {
      const res: IAllShopImages = await this.shopService.albumShopPhotoList({
        shop_id: this.AuditForm.shopId || this.AuditForm.carShopId,
      });
      const cleaned = Object.fromEntries(Object.entries(res).filter(([, v]) => Array.isArray(v?.elements) && v.elements.length > 0));
      this.albumData = cleaned;
      this.albumBool = true;
    } else {
      console.log(this.val, 'this.val');
      this.albumBool = false;
    }
  }

  mounted() {
    this.watchAuditForm();

    this.watchValue();
  }
}
